<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-4 mt-4" outlined v-if="showcard == 1" rounded="lg">
            <v-card-title style="background-color: #f5f5f5;" class="text-h6 font-weight-bold text-primary">
                {{pltitulo}}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-list dense>
                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon color="success">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="text-wrap">Total de Acompañamientos Gratis: {{acomgratis}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon color="warning">mdi-clock-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="text-wrap">Utilizados: {{utilizados}}</v-list-item-title>
                            <template v-if="utilizados > 0">
                                <v-list-item-subtitle v-for="(repasociado, index) in repasociados" class="text-wrap">Reporte: {{repasociado}}</v-list-item-subtitle>
                            </template>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="showutilizado == 1">
                        <v-list-item-icon>
                            <v-icon color="error">mdi-alert-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="text-wrap">
                                Ya se utilizó un acompañamiento gratis, no lo puedes utilizar en este reporte
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
        <v-row v-if="!conclusion && permiso">
            <v-col>
                <v-btn @click="forms(true)" v-if="showAcompa == false || showAcompa == null" class="ma-2" color="primary">
                    Acompañamientos
                </v-btn>
                <v-btn @click="forms(false)" v-if="showAcompa == true || showAcompa == null" class="ma-2" color="primary">
                    Otros
                </v-btn>
            </v-col>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="!conclusion && permiso && showAcompa == true">
            <v-card-title class="justify-center primary" icon @click="showexpanded = !showexpanded" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Acompañamientos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ showexpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="showexpanded">
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-card-text>
                            <v-row justify="center" v-if="loaded == false">
                                <v-col cols="12" md="7">
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                                </v-col>
                            </v-row>
                            <v-row justify="center" v-if="loaded == true ">
                                <v-col cols="12" md="7">
                                    <div>
                                        <div class="mt-2">
                                            <span style="font-weight: bold;">Abogado:</span>
                                            <p class="type-text-style">{{ proveedor.prnombre }}</p>
                                        </div>
                                    </div>

                                    <v-row class="mt-3" align="center">

                                        <v-col cols="12" sm="6" md="6">
                                            <span style="font-weight: bold;">Fecha:</span>
                                            <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="fechaAcom"
                                                      persistent width="290px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div class="date-align-center">
                                                        <v-text-field v-model="fechaAcom" label="" readonly
                                                                      :rules="rulestextfechas" outlined dense v-bind="attrs"
                                                                      v-on="on"></v-text-field>
                                                    </div>
                                                </template>
                                                <v-date-picker v-model="fechaAcom" locale="es-mx" :min="minDateFhIni"
                                                               scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="modal = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text color="primary" @click="$refs.dialog.save(fechaAcom)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span style="font-weight: bold;">Costo:</span>
                                            <v-text-field v-model="Costo" label="" readonly
                                                          outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <div class="mt-4">
                                        <span style="font-weight: bold;">Observaciones:</span>
                                        <v-textarea id="textareaobs"
                                                    v-on:blur="observacionesSelected = observacionesSelected.trim()"
                                                    v-model="observacionesSelected" class="mt-2 textarea" :class="obsClass" outlined
                                                    hide-details :rules="rulestextarea" :maxlength="$store.state.maxLengthComentarios">
                                        </v-textarea>
                                        <v-row>
                                            <v-col>
                                                <span style="color: red">{{ obsError }}</span>
                                            </v-col>
                                            <v-col style="display: grid; place-items: end;">
                                                <span class="v-counter">{{ obsCounter }}/400</span>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>



                            <v-row justify="center" v-if="loaded == true">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="ma-2" color="primary" title="Guardar" @click="saveMovimientoProcess()"
                                           :disabled="disBtn">
                                        <span style="color: white">Guardar</span>
                                    </v-btn>

                                    <v-btn color="#FF4081" v-on:click="clearOptions()">
                                        <span style="color: white">Limpiar</span>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </div>
            </v-expand-transition>


        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="!conclusion && permiso && showAcompa == false">
            <v-card-title class="justify-center primary" icon @click="showexpanded = !showexpanded" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Otros Cobros</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ showexpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="showexpanded">
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-card-text>
                            <v-row justify="center" v-if="loaded == false">
                                <v-col cols="12" md="7">
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                                </v-col>
                            </v-row>
                            <v-row justify="center" v-if="loaded == true ">
                                <v-col cols="12" md="7">
                                    <div>
                                        <div class="mt-2">
                                            <span style="font-weight: bold;">Abogado:</span>
                                            <p class="type-text-style">{{ proveedor.prnombre }}</p>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <span style="font-weight: bold;">Fecha:</span>
                                        <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="fechaAcom"
                                                  persistent width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="date-align-center">
                                                    <v-text-field v-model="fechaAcom" label="" readonly
                                                                  hide-details outlined dense v-bind="attrs"
                                                                  v-on="on"></v-text-field>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="fechaAcom" locale="es-mx" :min="minDateFhIni"
                                                           scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="modal = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary" @click="$refs.dialog.save(fechaAcom)">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>

                                    <div class="mt-4">
                                        <span style="font-weight: bold;">Motivo:</span>
                                        <multiselect v-model="motivo"
                                                     deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                                     select-label="Seleccione una opción" track-by="ctcid" label="ctcconcepto"
                                                     placeholder="Seleccione una opción" :options="opcionesMotivo" :allow-empty="false" dense>
                                        </multiselect>
                                        <div v-if="errorMotivo">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Indique una opción
                                            </span>
                                            <br />
                                        </div>
                                    </div>

                                    <v-row class="mt-3" align="center" v-if="motivo != null">
                                        <v-col cols="12">
                                            <span style="font-weight: bold;">Costo:</span>
                                            <v-text-field v-model="CostoE" outlined dense label=""
                                                          :maxlength="8"
                                                          :rules="rulesInputsNumber"
                                                          @keypress="ruleMoney($event, CostoE)"></v-text-field>

                                        </v-col>
                                    </v-row>

                                    <div class="mt-4">
                                        <span style="font-weight: bold;">Observaciones:</span>
                                        <v-textarea id="textareaobs"
                                                    v-on:blur="observacionesSelected = observacionesSelected.trim()"
                                                    v-model="observacionesSelected" class="mt-2 textarea" :class="obsClass" outlined
                                                    hide-details :rules="rulestextarea" :maxlength="$store.state.maxLengthComentarios">
                                        </v-textarea>
                                        <v-row>
                                            <v-col>
                                                <span style="color: red">{{ obsError }}</span>
                                            </v-col>
                                            <v-col style="display: grid; place-items: end;">
                                                <span class="v-counter">{{ obsCounter }}/400</span>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>



                            <v-row justify="center" v-if="loaded == true">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="ma-2" color="primary" title="Guardar" @click="saveMovimientoProcess()"
                                           :disabled="disBtn">
                                        <span style="color: white">Guardar</span>
                                    </v-btn>

                                    <v-btn color="#FF4081" v-on:click="clearOptions()">
                                        <span style="color: white">Limpiar</span>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </div>
            </v-expand-transition>


        </v-card>


        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="card-title-style">
                <v-toolbar-title id="titulocard">Historial</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <v-row v-if="this.mostrarHistorial">
                    <v-col cols="12" md="12" v-if="permisoCobros == true">
                        <DataTable :url="urlListado" :columns="columns"
                                   :params="displayInputs" :order="[]" @apiDT="apiDT = $event"></DataTable>
                    </v-col>
                    <v-col cols="12" md="12" v-if="permisoCobros == false">
                        <DataTable :url="urlListado" :columns="columnsSinPermiso"
                                   :params="displayInputs" :order="[]" @apiDT="apiDT = $event"></DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import { mapMutations, mapState } from "vuex";
    import reporteGeneral from "@/services/ReporteGeneral/ReporteGeneral.service.js";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable
        },
        data() {
            return {
                errorMotivo: false,
                opcionesMotivo: [],
                rulesInputsNumber: [],
                motivo: null,
                CostoE: "",
                showAcompa: null,
                repasociados: [],
                utilizados: 0,
                showutilizado: 0,
                acomgratis: 0,
                pltitulo: '',
                showcard: 0,
                showexpanded: true,
                permisoCobros: null,
                permiso: false,
                mostrarHistorial: true,
                obtenerproveedor: [],
                proveedor: {
                    prclave: "",
                    prnombre: ""
                },
                fechaAcom: '',
                minDateFhIni: '',
                rulestextfechas: [v => !!v || 'Campo requerido'],
                conclusion: true,
                validForm: true,
                loaded: false,
                obsError: "",
                obsCounter: "",
                Costo: "",
                respCostoAcom: [],
                rulestextarea: [
                    (v) => {
                        if (v == null || v == "") {
                            return "Campo requerido";
                        } else {
                            if (v.trim().length < 12) {
                                return "Mínimo 12 Carácteres";
                            } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                                return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                            } else {
                                return true;
                            }
                        }
                    },
                ],
                observacionesSelected: "",
                obsClass: "",
                dialog: false,
                modal: false,
                load: false,
                disBtn: false,
                datosReporte: null,
                mostrarAlert: false,
                urlListado: "ReporteGeneral/ObtenerAcompananteReporte",
                columns: [
                    { name: 'ctcconcepto', data: 'ctcconcepto', title: "Tipo Cobro", orderable: true },
                    { name: 'csfhacomp', data: 'csfhacomp', title: "Fecha Acompañamiento" },
                    {
                        name: 'cscosto', data: 'cscosto', title: "Costo", render: (data) => {
                            if (data == 0) {
                                return 'Gratuito';
                            }
                            if (data) {
                                // Formatea el costo como pesos mexicanos
                                return `$${parseFloat(data).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                            }
                            return '$0.00'; // Valor predeterminado si `data` es nulo o indefinido
                        }
                    },
                    { name: 'estatus', data: 'estatus', title: "Estatus de Pago" },
                    { name: 'csobs', data: 'csobs', title: "Observaciones" },
                    { name: 'uslogin', data: 'uslogin', title: "Usuario" },
                    { name: 'csfhalta', data: 'csfhalta', title: "Fecha" },

                ],
                columnsSinPermiso: [
                    { name: 'ctcconcepto', data: 'ctcconcepto', title: "Tipo Cobro", orderable: true },
                    { name: 'csfhacomp', data: 'csfhacomp', title: "Fecha Acompañamiento" },
                    { name: 'estatus', data: 'estatus', title: "Estatus de Pago" },
                    { name: 'csobs', data: 'csobs', title: "Observaciones" },
                    { name: 'uslogin', data: 'uslogin', title: "Usuario" },
                    { name: 'csfhalta', data: 'csfhalta', title: "Fecha" },

                ],
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                    aiclave: ""
                },
            };

        },
        computed: {

            ...mapState(["domain"]),


        },
        async mounted() {
            this.changeReporteMenuOption('Cobros');
            this.datosReporte = await MetodosGenerales.obtenerSessionReporte("reporte");
            this.displayInputs = {
                nrreporte: this.datosReporte.nrreporte,
                svindice: this.datosReporte.svindice,
                aiclave: this.datosReporte.aiclave,
            };



            let validaConc = await MetodosGenerales.getReporteEstatus(this);

            if (validaConc == 2) {
                this.conclusion = true;
            }
            else {
                this.conclusion = false;
            }

            let today = new Date().toJSON().slice(0, 10);
            this.fechaAcom = today;

            await this.obtenerDatos();

            await MetodosGenerales.verificarPermisoSolo(
                this.domain.domainNameForApi,
                "VerificarPermiso",
                "388"
            ).then((response) => {
                if (response.data.length > 0) {
                    this.permiso = true;
                }
            });

            if (!this.conclusion) {
                await this.cargaCosto();
            }

            this.loaded = true;
        },

        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            async forms(val) {

                this.observacionesSelected = "";
                let today = new Date().toJSON().slice(0, 10);
                this.fechaAcom = today;
                this.CostoE = "";
                this.motivo = null;
                this.errorMotivo = false;
                this.obsError = "";


                if (!val) {
                    reporteGeneral.obtenerMotivosAcomp(this);
                }
                this.showAcompa = val;

                if (this.showexpanded) {
                    setTimeout(() => { this.$refs.form.resetValidation(); }, 500);
                }



            },
            ruleMoney: function ($event, value) {

                if (value == '') {
                    if ($event.charCode >= 49 && $event.charCode <= 57) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }
                else {
                    if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }

                }
            },
            async obtenerDatos() {
                await reporteGeneral.ObtenerDatosReporteAcompanamiento(this).then(response => {
                    this.proveedor.prclave = response.data[0].prclave;



                    this.proveedor.prnombre = response.data[0].prnombre;
                    this.minDateFhIni = response.data[0].svfhreporte;
                    this.permisoCobros = response.data[0].permisoCobros;
                    this.showcard = response.data[0].showcard;
                    if (this.showcard == 1) {
                        this.pltitulo = response.data[0].pltitulo;
                        this.acomgratis = response.data[0].acomgratis;
                        this.showutilizado = response.data[0].showutilizado;
                        this.utilizados = response.data[0].utilizados;
                        let cadena = response.data[0].repasociados;
                        if (cadena != null) {
                            this.repasociados = cadena.split(', ');
                        }


                    }

                });
            },
            clearOptions() {
                this.observacionesSelected = "";
                let today = new Date().toJSON().slice(0, 10);
                this.fechaAcom = today;
                this.CostoE = "";
                this.motivo = null;
                this.errorMotivo = false;
                this.obsError = "";
                this.$refs.form.resetValidation();
            },
            async cargaCosto() {
                this.respCostoAcom = await reporteGeneral.CostoAcompanamiento(this.datosReporte);

                this.Costo = this.respCostoAcom.data[0].Costo;
                if (this.Costo == 0) {
                    this.Costo = "Gratuito";
                }
                else {
                    this.Costo = `$${parseFloat(this.Costo).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                }

            },

            async saveMovimientoProcess() {


                if (this.observacionesSelected == null || this.observacionesSelected == "") {
                    this.obsError = "Campo requerido";
                } else {
                    if (this.observacionesSelected.trim().length < 12) {
                        this.obsError = "Mínimo 12 Carácteres";
                    } else if (this.observacionesSelected.trim().length > this.$store.state.maxLengthComentarios) {
                        this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                    }
                }

                if (this.motivo == null) {
                    this.errorMotivo = true;
                }


                let formValidation = this.$refs.form.validate();
                this.disBtn = true;

                if (!formValidation) {
                    this.disBtn = false;
                    return;
                }
                let params = {
                    nrreporte: this.datosReporte.nrreporte,
                    svindice: this.datosReporte.svindice,
                    acfacomp: this.fechaAcom,
                }
                let resp = await reporteGeneral.validaAcompanamiento(params);


                if (resp[0].valida) {
                    this.guardar();
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'info',
                        title: "Confirmación",
                        html: "Ya cuenta con un Acompañamiento ó Servicio en la fecha " + this.fechaAcom + " ¿Desea continuar?",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.guardar();
                        }
                        else {
                            this.disBtn = false;
                        }
                    });
                }

            },
            async guardar() {
                this.mostrarHistorial = false;
                this.$swal({
                    position: "center",
                    title: "Cargando...",
                    html: "Espere un momento por favor",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();

                try {
                    let paramInsertAcom = {
                        nrreporte: this.datosReporte.nrreporte,
                        svindice: this.datosReporte.svindice,
                        prclave: this.proveedor.prclave,
                        acfacomp: this.fechaAcom,
                        accosto: this.showAcompa ? this.respCostoAcom.data[0]?.Costo : this.CostoE,
                        acobservaciones: this.observacionesSelected,
                        accertifciado: this.respCostoAcom.data[0].dacertificado,
                        plid: this.respCostoAcom.data[0].plid,
                        ctcid: this.showAcompa ? 1 : this.motivo.ctcid
                    }
                    let resp = await reporteGeneral.AgregarAcompanamiento(paramInsertAcom);




                    if (resp == 1) {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Éxito!",
                            html: "Se ha guardado correctamente",
                            allowOutsideClick: false,
                            showConfirmButton: true,
                            timer: 3000,
                        }).then(async () => {
                            this.obtenerDatos();
                            this.cargaCosto();
                            this.clearOptions();
                            this.showAcompa = null;
                            this.disBtn = false;
                            return;
                        });
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            html: "Hubo un error al guardar, comuniquese con desarrollo@ausa.com.mx",
                            allowOutsideClick: false,
                            showConfirmButton: true,
                            timer: 3000,
                        }).then(async () => {
                            this.disBtn = false;
                            return;
                        });


                    }
                } catch (e) {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Algo salio mal " + e,
                        html: "Algo salio mal, por favor intente de nuevo mas tarde",
                        allowOutsideClick: false,
                        showConfirmButton: true,
                    });
                }
                this.mostrarHistorial = true;
            }


        },
        watch: {
            motivo(val) {
                this.CostoE = "";
                if (val == null) {
                    return
                }
                this.errorMotivo = false;
                if (val.ctcmonto != 0) {
                    this.CostoE = val.ctcmonto;
                }
                this.rulesInputsNumber = [];
                this.rulesInputsNumber.push((v) => {
                    if (v == null || v == '') {
                        return 'Monto Invalido';
                    } else {
                        if (v < val.ctcmontomin || v > val.ctcmontomax) {
                            return 'El monto debe ser entre ' + val.ctcmontomin + ' y ' + val.ctcmontomax;
                        }
                        else {
                            return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                        }

                    }
                    return true
                });
            },
            observacionesSelected(val) {
                if (val != "") {
                    this.obsError = "";
                }
                this.obsCounter = this.observacionesSelected.length.toString();
            },

        },
    };
</script>
<style>
</style>
<style scoped>
    .card-title-style {
        background-color: #536dfe;
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1.1em;
        color: white;
    }

    .textarea {
        resize: none !important;
    }

    .type-text-style {
        font-family: "Poppins", sans-serif;
        font-weight: 700;
        font-size: 1.3em;
    }
</style>
